import React, { useState, useEffect } from "react";
import axios from "axios";
import "./RemoveCoupons.css";
import Adminnav from "../Adminnav";
import toastify from "../../Util/toastify";
import BaseURL from "../../Util/BaseURL";
const RemoveCoupons = () => {
  const [coupons, setCoupons] = useState();

  function remove(props) {
    axios.delete(`${BaseURL}deleteCoupon?code=${props}`, {
      headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") },
    });
    document.getElementById(props).style.display = "none";
    toastify("Coupon Deleted Successfully", "success");
  }
  const getCoupons = async () => {
    const response = await axios.get(`${BaseURL}GetCoupons`, {
      headers: { Authorization: "Bearer " + sessionStorage.getItem("pic") },
    });
    setCoupons(response.data);
  };
  useEffect(() => {
    getCoupons();
  }, []);
  return (
    <>
      <Adminnav />
      <section id="hero">
        <div className="hero-container">
          <div className="hero-logo row">
            <h1 className="font-weight-bold col">Remove Coupons</h1>
          </div>
        </div>
      </section>
      <div className="row row-cols-lg-4 row row-cols-md-3 row-cols-sm-1 h-100 w-100 p-5 mx-auto">
        {coupons
          ? coupons.map((data,key) => (
              <div
                key={key}
                className="col singleCard card target py-5"
                id={data.couponCode}
              >
                <div className="col card-body text-center">
                  <h4>{data.couponCode}</h4>
                  <h6>Discount: {data.discount}</h6>
                  <button
                    className="btn btn-success rmv"
                    onClick={() => remove(data.couponCode)}
                  >
                    Remove Coupon
                  </button>
                </div>
              </div>
            ))
          : ""}
      </div>
    </>
  );
};

export default RemoveCoupons;
